import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import Loading from "../../../../components/loading";
import "./styles/viaturaInfo.css";

export function ViaturaInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllViaturaEmergenciaById(id, config).then(
                    (res) => {
                        setData(res);
                    }
                );
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    console.log("data:", data);

    const convertBoll = (value) => {
        if (value === 1) return "Conforme";
        if (value === 0) return "Não Conforme";
    };

    return (
        <div>
            <div className="container-viatura-info">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">
                        Equipamentos da viatura de emergência
                    </h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main className="datagrid-container">
                            <div className="table-content">
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Data da inspeção</th>
                                            <th>2 mangueiras de incêndio de 2(1/2)</th>
                                            <th>4 mangueiras de incêndio de 1(1/2)</th>
                                            <th>1 esguicho de jato regulável 2(1/2)</th>
                                            <th>2 esguichos de jato regulável 1(1/2)</th>
                                            <th>1 derivante com 02 saídas de 1(1/2)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>{formatDate(check.data)}</td>
                                        <td>{convertBoll(check.duasMangInc_25)}</td>
                                        <td>{convertBoll(check.quatroMangInc_15)}</td>
                                        <td>{convertBoll(check.umEngJatoReg_25)}</td>
                                        <td>{convertBoll(check.doisEngJatoReg_15)}</td>
                                        <td>{convertBoll(check.umDeriv2Sai_15)}</td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>1 lançador e 1 proporcionador de espuma(entre linhas)</th>
                                            <th>2 bombonas de líquido gerador de espuma - 20Litros</th>
                                            <th>4 chaves de mangueira</th>
                                            <th>3 pares de luva PVC</th>
                                            <th>2 rolos de cerquite</th>
                                            <th>3 máscaras faciais inteiras com filtro multiuso</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>{convertBoll(check.umLancUmProp)}</td>
                                        <td>{convertBoll(check.duasBombLiqGer)}</td>
                                        <td>{convertBoll(check.quatroChavMang)}</td>
                                        <td>{convertBoll(check.tresParLuva)}</td>
                                        <td>{convertBoll(check.doisRolosCerq)}</td>
                                        <td>{convertBoll(check.tresMascFacInt)}</td>
                                    </tbody>
                                </div>
                            </div>
                        </main>
                    );
                })}
            </div>
        </div>
    );
}
